import React from 'react';
import { Typography } from '@mui/material';

import styles from './EmailScriptConfiguration.module.scss';

export function DescriptionView() {
  return (
    <section className={styles.descriptionView}>
      <Typography variant="bodyDefault">
        <b>Email Sources</b> are a simple way to create Flows from data in emails. Create an email
        source and define forwarding rules to the uniquely generated Email ID. Nexla will monitor
        the Email ID for incoming data and detect whether the new email mapped into a new or
        existing Nexset.
      </Typography>

      <Typography variant="bodyDefault">
        We currently support extraction of Nexsets from email attachments and structured data in
        content. Select the Image/ PDF Dataset Detection Mode for non-text based attachments that
        require OCR Text Recognition.
      </Typography>

      <Typography variant="bodyDefault">
        Note that a multi-tab Excel attachment might result in one detected Nexset per sheet.
      </Typography>

      <Typography variant="h6">Email Sources enable you to:</Typography>

      <ul>
        <li>
          <Typography variant="bodyDefault">Push data through Nexla from email</Typography>
        </li>
        <li>
          <Typography variant="bodyDefault">
            Use the same Data Source for different types of attachments or structured content
          </Typography>
        </li>
        <li>
          <Typography variant="bodyDefault">
            Create automated flows with transformations and destination rules like any other Data
            Source
          </Typography>
        </li>
      </ul>
    </section>
  );
}
